import React from 'react';
import { useParams } from 'react-router-dom';
import './App.css';

function SuccessPage() {
  const { termId } = useParams();

  return (

    <main className="main-content">
      <h1>Thank you for accepting the RICS Homebuyer Report terms and conditions. You will receive a confirmation email confirming your acceptance.</h1>
      <h2>If you're unsure about anything or wish to cancel, please call us on <span className='bold-midnight-blue'>01536 534594</span> quoting your reference: {termId}</h2>
    </main>

  );
}

export default SuccessPage;


